// Libraries
import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */

/**
 * @class RecaptchaFormController
 * @extends Controller
 * @description Perform recaptcha checks before submitting form element.
 */
class RecaptchaFormController extends Controller {
    static targets = ['input', 'submit'];
    static values = {
        token: String,
    };

    /**
     * @method processRecaptcha
     * @description Perform recaptcha checks on form submit
     *
     * @return {void}
     */
    processRecaptcha() {
        this.submitTarget.disabled = true;

        if (this.element.hasAttribute('data-recaptcha-done')) {
            this.element.submit();
            return;
        }

        if (this.validateRecaptcha() === false) {
            const alertDiv = document.createElement('div');

            alertDiv.classList.add('alert', 'alert-warning', 'mb-4', 'd-block');
            alertDiv.setAttribute('role', 'alert');
            alertDiv.textContent =
                'There was an issue loading recaptcha, please reload the page and try again.';

            this.submitTarget.parentNode.insertBefore(
                alertDiv,
                this.submitTarget
            );
        }

        grecaptcha
            .execute(this.tokenValue, { action: 'submit' })
            .then((token) => {
                const input = document.createElement('input');

                input.type = 'hidden';
                input.name = 'g-recaptcha-response';
                input.value = token;

                this.element.appendChild(input);
                this.element.setAttribute('data-recaptcha-done', true);
                this.element.submit();
            });
    }

    /**
     * @method validateRecaptcha
     * @description Checks that the recaptcha execute function exists
     *
     * @returns {boolean}
     */
    validateRecaptcha() {
        if (typeof grecaptcha === 'undefined') {
            return false;
        }

        if (typeof grecaptcha.execute !== 'function') {
            return false;
        }

        return true;
    }
}

// Exports
export default RecaptchaFormController;
